<template>
  <div id="dashboard">
    <Sidebar />
    <div class="dashboard-content">
      <div class="container">
        <Heading />
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from "../components/dashboard/partiels/Heading.vue";
import Sidebar from "../components/partiels/Sidebar.vue";

export default {
  components: { Heading, Sidebar },
};
</script>
<style lang="scss" scoped>
.navbar {
  padding-left: 270px;
}
.bg-dark {
  background-color: #000dff !important;
}
@media (min-width: 1200px) {
  .dashboard-content {
    padding-left: 270px;
  }
}
@media (max-width: 1199.98px) {
}
</style>